import type { SVGProps } from 'react';
const SvgRead = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <g clipPath="url(#Read_svg__a)">
      <path
        d="M14.5 5.5 9 2c-.243-.168-.705-.5-1-.5s-.757.332-1 .5L1.5 5.5m13 0v9h-13v-9m13 0-4.5 4m-8.5-4 4.5 4m8 4.5L9 9.5c-.243-.27-.705-.585-1-.585s-.757.315-1 .585L2 14"
        strokeLinejoin="round"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth={1.5}
      />
    </g>
    <defs>
      <clipPath id="Read_svg__a">
        <path d="M0 0h16v16H0z" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgRead;
